exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uploading-image {\n  display: -webkit-box;\n  display: flex;\n  width: 70px;\n  height: 70px;\n}\n", ""]);

// exports
